function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.00441 0.5C4.00441 0.223857 4.22826 0 4.50441 0H8.30963C8.58577 0 8.80963 0.223858 8.80963 0.5V3.10276H8.99078C9.21169 3.10276 9.39078 3.28185 9.39078 3.50276V4.26705C9.39078 4.48796 9.56986 4.66705 9.79078 4.66705H10.8933H11.6105C12.1628 4.66705 12.6105 5.11477 12.6105 5.66705V23.1466C12.6105 23.6987 12.1629 24.1464 11.6108 24.1466L1.00032 24.1499C0.447909 24.1501 0 23.7023 0 23.1499V5.66705C0 5.11477 0.447715 4.66705 1 4.66705H1.60985H2.87336C3.09427 4.66705 3.27336 4.48796 3.27336 4.26705V3.50276C3.27336 3.28185 3.45244 3.10276 3.67336 3.10276H4.00441V0.5ZM4.80525 0.800854H7.92865V2.88312H4.80525V0.800854ZM9.61038 16.0174C9.61038 17.7867 8.17614 19.2209 6.4069 19.2209C4.63767 19.2209 3.20342 17.7867 3.20342 16.0174C3.20342 14.2482 4.63767 12.814 6.4069 12.814C8.17614 12.814 9.61038 14.2482 9.61038 16.0174Z",
  fill: "current"
});

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 25,
    viewBox: "0 0 13 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.749d8573.svg";
export { ForwardRef as ReactComponent };